class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

      if(this.dataset.bundleItemId){
        const bundleItemsIdArray = this.dataset.bundleItemId.split(', ');
        await this.removeBundleItemsFromCart(bundleItemsIdArray);
        // console.log('executed');
        await delay(3000);
      }
        cartItems.updateQuantity(this.dataset.index, 0);
    });
  }

  async removeBundleItemsFromCart(variantIds) {

  
    try {
      // Fetch the current cart state
      const response = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      const cart = await response.json();
  
      // Create updates object to set quantity to 0 for each variantId
      const updates = {};
      // console.log(variantIds)
      
  
      variantIds.forEach(variantId => {
        const matchingItem = cart.items.find((item) => {
          if(item.product_title == variantId){
            return document.querySelectorAll(`[data-item-id="${item.id}"]`).length > 0 ? false : item.variant_id
            return item.variant_id;
          }
        });
        if (matchingItem) {
          updates[matchingItem.key] = 0; // Use key if available, else use variant_id
        }
      });
      // console.log({updates});
      if (Object.keys(updates).length > 0) {
        // Send the update request to remove items
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ updates })
        });
  
        const updatedCart = await updateResponse.json();
        // console.log('Cart updated:', updatedCart);
        
      } else {
        console.log('No matching items found in the cart for the given variant IDs.');
      }
    } catch (error) {
      console.error('Error handling cart operations:', error);
    }
  }

}
const miniPay = document.querySelector(".additional-checkout-buttons") || document.querySelector(".drawer-ctas") || document.querySelector(".drawer__footer");
// const cartPay = document.querySelector("#MainContent .checkout-btns") || document.querySelector("#MainContent .cart__ctas");
const cartCheckout = document.querySelector("#MainContent .cart__ctas");
const cartPay = document.querySelector("#MainContent .checkout-btns ");
if(miniPay){
  miniPay.addEventListener('click',(e)=>{
    // console.log({el:e.target});
    // showAllloader();
    const removeButtons= document.querySelectorAll("cart-remove-button button")
    if(removeButtons && removeButtons.length > 0){
      removeButtons.forEach((el)=>{
        // console.log({el});
        
        el.setAttribute("disabled",""); 
        el.classList.add("hide");
      }) 
      // console.log("Number of open windows:", {frames:window.frames});
      /* setInterval(() => {
        console.log("Number of open windows:", {frames:window.frames});
    }, 2000);  */    
    }
    
  })
}
function preaActionCartcheckout() {
  // showAllloader();
  const removeButtons= document.querySelectorAll("cart-remove-button")    
  removeButtons && removeButtons.length > 0 && removeButtons.forEach((el)=>{el.setAttribute("disabled",""); el.classList.add("hide");})
}

cartPay && cartPay.addEventListener('click',(e)=>preaActionCartcheckout())
cartCheckout && cartCheckout.addEventListener('click',(e)=>preaActionCartcheckout())

const path = window.location.pathname.split("/");
//console.log({path});
//console.log(path[path.length - 1]);
if(!(path.length > 1 && path[path.length-1] == 'cart'))
customElements.define('cart-remove-button', CartRemoveButton); 

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === "cart-items") {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    if (event.target.id != "request_invoice" && event.target.id != "tax-number")
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  async updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    console.log("step -1");
    let oldTotalPrice = typeof currentTotalCartPrice === "undefined" ? 0 : currentTotalCartPrice;
    let updatePrice = 0;
    const _freeProductPriceLimit = typeof freeProductPriceLimit === "undefined" ? 0 : freeProductPriceLimit;
    const additional_fragrance_samplesLimit = typeof additionalFragranceSamplesLimit === "undefined" ? 0 : additionalFragranceSamplesLimit;
    /* if(document.querySelectorAll(".free-product-row cart-remove-button").length > 0 && !oldTotalPrice){
      await this.getCartInfo ()
    } */
    //await this.getCartInfo ();
    console.log("step -2");
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    let cartStatus = {};
    // console.log({update_qbody:body,path:routes.cart_change_url});
    const drawer_ctas = document.querySelectorAll(".drawer-ctas");
    if(drawer_ctas != null && drawer_ctas.length > 0){
      // drawer_ctas.setAttribute("disabled",true)
      drawer_ctas.forEach(dcel =>{
        dcel.setAttribute("disabled",true)
        const dcel_childs = dcel.querySelectorAll("*")
        if(dcel_childs!= null && dcel_childs.length > 0){
          dcel_childs.forEach(dcel_child=>{
            dcel_child.addEventListener('click',e =>{
              e.preventDefault();
            })
            dcel_child.setAttribute("disabled",true)
          })
        }
      })
    }
    // return 0
    
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);
        cartStatus = parsedState;
        // console.log({ parsedState });
        updatePrice = parsedState.total_price;
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter) cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

       /*  this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = "";
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace("[quantity]", updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector(".drawer__inner-empty"), cartDrawerWrapper.querySelector("a"));
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name"));
        } */


        // debugger;
        const giftItems = document.querySelectorAll("input[name=gift_product_id]");
        if (giftItems != null) {
          let giftItemsIds = [];
          let totalPrice = 0;
          let notGiftProducts = [];
          document.querySelectorAll("input[name=gift_product_id]").forEach((element) => {
            giftItemsIds.push(element.value);
          });
          cartStatus.items.forEach((element) => {
            if (!giftItemsIds.includes(element.variant_id + "")) {
              totalPrice += element.final_line_price;
              notGiftProducts.push(element);
            }
          });
          /* console.log({
            giftItemsIds,
            totalPrice,
            notGiftProducts,
            removeGiftProducts: totalPrice < additional_fragrance_samplesLimit,
          }); */
          // if (totalPrice < _freeProductPriceLimit) await this.removeGiftProducts();
          if (totalPrice < additional_fragrance_samplesLimit) await this.removeGiftProducts();
        }

        //

        /* console.log({
          updatePrice,
          "updatePrice >= _freeProductPriceLimit":updatePrice >= _freeProductPriceLimit,
          "oldTotalPrice >= _freeProductPriceLimit":oldTotalPrice >= _freeProductPriceLimit,
          "updatePrice < _freeProductPriceLimit":updatePrice < _freeProductPriceLimit,
          oldTotalPrice,
          _freeProductPriceLimit,
          ".free-product-row cart-remove-button":document.querySelectorAll(".free-product-row cart-remove-button").length

        }); */

        if(oldTotalPrice != 0 && additional_fragrance_samplesLimit != 0 && updatePrice < oldTotalPrice && updatePrice < additional_fragrance_samplesLimit ){
          const reDat = await this.removeFreeProducts()
          if(reDat){
            const responceData = await reDat.json();
            // console.log({reDat:responceData});
          }
          /* else
            console.log({reDat}); */

          
        }
            
        // debugger


        // publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items", cartData: parsedState, variantId: variantId });
        setTimeout(() => {
          document.location.href = '/cart'
        }, 500);
        
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) => overlay.classList.add("hidden"));
        const errors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      
  }

  async getCartInfo() {
    const cart_url = `${routes.cart_url}.js`;
    // console.log(cart_url);
    const cart = await fetch(cart_url);
    // console.log("cart response", await cart.json());
  }

  async removeFreeProducts() {
    // debugger;
    console.log("removing free products ...");
    let updates = {};
    const select_cosnt = `#cart .free-product-row:not(.${cartbot}) cart-remove-button`;
    const freeProducts = document.querySelectorAll(select_cosnt);
    if (freeProducts == null) return false;
    freeProducts.forEach((element) => {
      updates[element.dataset.itemId] = 0;
    });

    if (Object.keys(updates).length > 0){
      // Send the update request to remove items
      // const updateResponse = 
      // debugger;
      // console.log({updates});
      
      
      const body = JSON.stringify({updates});
        return await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      

      return true;
      // debugger;
    } else {
      console.log('No matching items found in the cart for the given variant IDs.');
    };

    /* const body = JSON.stringify({ updates });
    console.log({removeFreeProducts_qbody:body,path_re:routes.cart_change_url,updates});
    debugger;
    return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }); */
  }
  async removeGiftProducts() {
    console.log("removing gift products ...");

    let updates = {};
    const giftItems = document.querySelectorAll("input[name=gift_product_id]");
    if (giftItems == null) return false;

    giftItems.forEach((element) => {
      updates[element.value] = 0;
    });
    // console.log({ updates });

    if (Object.keys(updates).length == 0) return false;

    const body = JSON.stringify({ updates });
    return await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove("hidden"));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
    // showAllloader();
    const loderEl = document.querySelector('#MainContent.cart-section') ;
    const minicatr = document.querySelector('#CartDrawer') ;
    ( loderEl!= null) && loderEl.classList.add("add-loader");
    ( minicatr!= null) && minicatr.classList.add("add-loader");
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    const loderEl = document.querySelector('#MainContent.cart-section');    
    const minicatr = document.querySelector('#CartDrawer') ;
    ( loderEl!= null) && loderEl.classList.remove("add-loader");
    ( minicatr!= null) && minicatr.classList.remove("add-loader");
  }
}
function showAllloader() {
  const loderEl = document.querySelector('#MainContent.cart-section') ;
  const minicatr = document.querySelector('.drawer.active #CartDrawer') ;
  // ( loderEl!= null) && loderEl.classList.add("add-loader");
  ( minicatr!= null) ? minicatr.classList.add("add-loader") :(( loderEl!= null) && loderEl.classList.add("add-loader"))
  // (( minicatr!= null) && minicatr.classList.add("add-loader")) || (( loderEl!= null) && loderEl.classList.add("add-loader"));
}
function hideAllloader() {
  const loderEl = document.querySelector('#MainContent.cart-section');    
  const minicatr = document.querySelector('#CartDrawer') ;
  ( loderEl!= null) && loderEl.classList.remove("add-loader");
  ( minicatr!= null) && minicatr.classList.remove("add-loader");
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

const cartOffers = document.querySelectorAll(".component-gift .choose");

if (cartOffers != null) {
  cartOffers.forEach(element => {
    element.addEventListener('click',(e)=>{
      const parent = e.target.closest('.component-gift').classList.toggle('open');
      
    })
  });
}
const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
      console.log("DOM changed:", mutation);
  });
});

observer.observe(document.body, { childList: true, subtree: true });

(function ($) {
  $.fn.hasScrollBar = function (direction) {
    if (direction == "vertical") {
      return this.get(0).scrollHeight > this.innerHeight();
    } else if (direction == "horizontal") {
      return this.get(0).scrollWidth > this.innerWidth();
    }
    return false;
  };

  const sliders = $(".slide-button-full");
  if (sliders.length > 0) {
    sliders.each((index, element) => {
      $(element).append(
        '<span class="move-left najoleari-icon-icon-chevron-left"></span><span class="move-right najoleari-icon-icon-chevron-right"></span>'
      );

      $(element)
        .find(".move-right")
        .on("click", (e) => {
          const parentWidth = $(element).width();
          const child = $(element).find(".slide-content");
          let nextLi = $(element).find(".slide-content > .slider-list:nth-child(1)");
          let nextWidth = nextLi.width();
          let childWidth = 0;
          // console.log(child.width(), child.hasScrollBar("vertical"), child.hasScrollBar("horizontal"));
          $(element)
            .find(".slide-content > .slider-list")
            .each((index_c, element_c) => {
              childWidth += $(element_c).width();
            });
          // console.log({ parentWidth, childWidth, nextWidth });
          if (child.hasScrollBar("horizontal")) {
            const childScroll = child.scrollLeft();
            // child.scrollLeft( childScroll + nextWidth )
            child.animate({ scrollLeft: childScroll + nextWidth }, 300);
          } else {
            let pos = child.position().left;
            pos = pos - nextWidth;

            if (pos < (childWidth - parentWidth) * -1) pos = (childWidth - parentWidth) * -1;
            child.css("left", `${pos}px`);
          }
        });
      $(element)
        .find(".move-left")
        .on("click", (e) => {
          const parentWidth = $(element).width();
          const child = $(element).find(".slide-content");
          let nextLi = $(element).find(".slide-content > .slider-list:nth-child(1)");
          let nextWidth = nextLi.width();
          const childWidth = child.width();
          // console.log({ parentWidth, childWidth, nextWidth });
          if (child.hasScrollBar("horizontal")) {
            const childScroll = child.scrollLeft();
            // child.scrollLeft( childScroll - nextWidth )
            child.animate({ scrollLeft: childScroll - nextWidth }, 300);
          } else {
            let pos = child.position().left;
            pos = pos + nextWidth;
            if (pos > 0) pos = 0;
            child.css("left", `${pos}px`);
          }
        });
    });
  }

  ////------------
  $("#additional-fragrance-samples-products div.free-product-list-content ").on("click",function(e){
      // console.log({freeProductLimit});
      // debugger
    const productIds = [];
    console.log("free-product-list-content");
    
    
    const checkItem = $(this).find('.free-check');     
    if(checkItem.hasClass('disable')) return ;
    if(checkItem.hasClass('checked')){
      checkItem.removeClass('checked');
      
    }else{
      $("#additional-fragrance-samples-products div.free-product-list-content .free-check.checked").each((index,elp)=>{
        const input = $(elp).find('input[name="freeSample"]');

        productIds.push(input.val());
      })
      const productIdsU = productIds.filter((value, index, array) =>array.indexOf(value) === index);
      // console.log({productIdsU});
      if(productIdsU.length < additionalFragranceSamplesNumberLimit )
      checkItem.addClass('checked');
    }
    // console.log({productIds});
    
  })
  $("#scented-cards-free-product div.free-product-list-content ").on("click",function(e){
      // console.log({freeProductLimit});
      // debugger
    const productIds = [];
    console.log("free-product-list-content");
    
    
    const checkItem = $(this).find('.free-check');     
    if(checkItem.hasClass('disable')) return ;
    if(checkItem.hasClass('checked')){
      checkItem.removeClass('checked');
      
    }else{
      $("#scented-cards-free-product div.free-product-list-content .free-check.checked").each((index,elp)=>{
        const input = $(elp).find('input[name="freeSample"]');

        productIds.push(input.val());
      })
      const productIdsU = productIds.filter((value, index, array) =>array.indexOf(value) === index);
      // console.log({productIdsU});
      if(productIdsU.length < freeProductLimit )
      checkItem.addClass('checked');
    }
    // console.log({productIds});
    
  })
  $("#fragrance-samples-products div.free-product-list-content ").on("click",function(e){
      // console.log({freeProductLimit});
      // debugger
    const productIds = [];
    
    const checkItem = $(this).find('.free-check');     
    if(checkItem.hasClass('disable')) return ;
    if(checkItem.hasClass('checked')){
      checkItem.removeClass('checked');
      
    }else{
      $("#fragrance-samples-products div.free-product-list-content .free-check.checked").each((index,elp)=>{
        const input = $(elp).find('input[name="freeSample"]');

        productIds.push(input.val());
      })
      const productIdsU = productIds.filter((value, index, array) =>array.indexOf(value) === index);
      // console.log({productIdsU});
      if(productIdsU.length < freeProductLimit )
      checkItem.addClass('checked');
    }
    // console.log({productIds});
    
  })
  $("#scented-samples-products div.free-product-list-content").on("click",function(e){
    const productIds = [];
    const checkItem = $(this).find('.free-check');     
    if(checkItem.hasClass('disable')) return ;
    if(checkItem.hasClass('checked')){
      checkItem.removeClass('checked');
    }else{
      $("#scented-samples-products div.free-product-list-content .free-check.checked").each((index,elp)=>{
        const input = $(elp).find('input[name="freeSample"]');

        productIds.push(input.val());
      })
      const productIdsU = productIds.filter((value, index, array) =>array.indexOf(value) === index);

      // if($("#scented-samples-products div.free-product-list-content .free-check.checked").length < scentedCandlesLimit)
      if(productIdsU.length < scentedCandlesLimit )
      checkItem.addClass('checked');
    }
  })
  $("#giftGiftBlock div.free-product-list-content ").on("click",function(e){
    const productIds = []; 
    const checkItem = $(this).find('.free-check');     
    if(checkItem.hasClass('disable')) return ;
    if(checkItem.hasClass('checked')){
      checkItem.removeClass('checked');
    }else{
      $("#giftGiftBlock div.free-product-list-content .free-check.checked").each((index,elp)=>{
        const input = $(elp).find('input[name="freeSample"]');

        productIds.push(input.val());
      })
      const productIdsU = productIds.filter((value, index, array) =>array.indexOf(value) === index);
      // if($("#giftGiftBlock div.free-product-list-content .free-check.checked").length < scentedCandlesLimit)
      // console.log({xx:productIdsU.length});
        if(productIdsU.length < scentedCandlesLimit )
      checkItem.addClass('checked');
    }
  })
  /* $("#giftGiftContainer .free-product-list > div.free-product-list-content ").on("click",function(e){
    
    const checkItem = $(this).find('.free-check');     
    if(checkItem.hasClass('disable')) return ;
    if(checkItem.hasClass('checked')){
      checkItem.removeClass('checked');
    }else{
      if($("#giftGiftContainer .free-product-list > div.free-product-list-content .free-check.checked").length < freeProductLimit)
      checkItem.addClass('checked');
    }
  }) */
 
})(jQuery);